import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from '@/components/layout/Layout'
import LoginPage from '@/pages/LoginPage'
import DashboardPage from '@/pages/DashboardPage'
import DashboardStatPage from '@/pages/DashboardStatPage'
import StudentsPage from '@/pages/StudentsPage'
import StudentProfilePage from '@/pages/StudentProfilePage'
import EmployeesPage from '@/pages/EmployeesPage'
import EmployeeProfilePage from '@/pages/EmployeeProfilePage'
import AttendancePage from '@/pages/AttendancePage'
import SchedulesPage from '@/pages/SchedulesPage'
import DevicesPage from '@/pages/DevicesPage'
import DepartmentsPage from '@/pages/DepartmentsPage'
import KafedraDetailPage from '@/pages/KafedraDetailPage'
import DirectionDetailPage from '@/pages/DirectionDetailPage'
import AnalyticsPage from '@/pages/AnalyticsPage'
import GroupAnalyticsPage from '@/pages/analytics/GroupAnalyticsPage'
import EmployeeDeptAnalyticsPage from '@/pages/analytics/EmployeeDeptAnalyticsPage'
import UsersPage from '@/pages/UsersPage'
import SettingsPage from '@/pages/SettingsPage'
import { useAuthStore } from '@/store/authStore'

function AppLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="flex flex-col items-center gap-3 text-gray-400">
        <div className="w-8 h-8 border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin" />
        <span className="text-sm">Загрузка...</span>
      </div>
    </div>
  )
}

function PublicRoute({ children }) {
  const token = useAuthStore((s) => s.token)
  return token ? <Navigate to="/dashboard" replace /> : children
}

function PrivateRoute({ children }) {
  const token = useAuthStore((s) => s.token)
  return token ? children : <Navigate to="/login" replace />
}

function AdminRoute({ children }) {
  const user = useAuthStore((s) => s.user)
  const roleName = user?.role_detail?.name || ''
  const allowed = ['super_admin', 'admin'].includes(roleName) || user?.is_staff
  return allowed ? children : <Navigate to="/dashboard" replace />
}

export default function App() {
  const hasHydrated = useAuthStore((s) => s._hasHydrated)

  if (!hasHydrated) return <AppLoader />

  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="dashboard/stat/:stat" element={<DashboardStatPage />} />
        <Route path="students" element={<StudentsPage />} />
        <Route path="students/:id" element={<StudentProfilePage />} />
        <Route path="employees" element={<EmployeesPage />} />
        <Route path="employees/:id" element={<EmployeeProfilePage />} />
        <Route path="attendance" element={<AttendancePage />} />
        <Route path="schedules" element={<SchedulesPage />} />
        <Route path="devices" element={<AdminRoute><DevicesPage /></AdminRoute>} />
        <Route path="departments" element={<DepartmentsPage />} />
        <Route path="departments/:id" element={<KafedraDetailPage />} />
        <Route path="departments/:id/directions/:dirId" element={<DirectionDetailPage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="analytics/groups/:id" element={<GroupAnalyticsPage />} />
        <Route path="analytics/employees-departments/:id" element={<EmployeeDeptAnalyticsPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  )
}
